import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'chart.js/auto';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { SidebarProvider } from './contexts/SidebarContext';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <ThemeProvider>
          <SidebarProvider>
            <App />
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 3000,
                style: {
                  background: 'rgba(15, 23, 42, 0.96)',
                  color: '#F1F5F9',
                  borderRadius: '16px',
                  fontSize: '13px',
                  padding: '12px 16px',
                  boxShadow: '0 16px 40px -16px rgba(15, 23, 42, 0.45)',
                },
                success: {
                  iconTheme: { primary: '#E6FF94', secondary: '#0F172A' },
                },
                error: {
                  iconTheme: { primary: '#F87171', secondary: '#0F172A' },
                },
              }}
            />
          </SidebarProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
